// Minimal path-based router. react-router isn't installed and this app only
// needs two entry points, so a few helpers are cheaper than the dependency.

export function getPath() {
	if (typeof window === 'undefined') return '/';
	const path = window.location.pathname || '/';
	// Normalise trailing slashes: /admin/ === /admin
	if (path.length > 1 && path.endsWith('/')) return path.replace(/\/+$/, '') || '/';
	return path;
}

export function isAdminRoute() {
	const path = getPath();
	return path === '/admin' || path.startsWith('/admin/');
}

export function goTo(path) {
	if (typeof window !== 'undefined') window.location.assign(path);
}